import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    client_vars: [],
    hasMounted: false,
    mapData: {}
  },
  mutations: {
    importStore (state, payload) {
      state.client_vars = payload
      state.hasMounted = true
    },
    mapData (state, payload) {
      state.mapData = payload
    }
  },
  getters: {
    getSocialUpdates: state => {
      return state.client_vars.socialSettings.socialFeeds
    },
    getToggles: state => {
      return state.client_vars.toggles
    },
    getLabels: state => {
      return state.client_vars.labels
    },
    getSocialSettings: state => {
      return state.client_vars.socialSettings
    },
    getMapConfig: state => {
      return state.client_vars.mapConfig
    },
    getLogo: state => {
      return state.client_vars.logo
    },
    getLogoLink: state => {
      return state.client_vars.logoLink
    },
    getMapData: state => {
      return state.mapData
    }
  }
})

export default store
